import { render, staticRenderFns } from "./PlayerVolumeControl.vue?vue&type=template&id=4d881fae&"
import script from "./PlayerVolumeControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlayerVolumeControl.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PlayerVolumeControl.vue?vue&type=style&index=0&id=4d881fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports